import type { JSX } from 'react'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'

export interface CircleLoaderSvgProps {
  radius?: number
  strokeWidth?: number
  dashOffset: number
  circumference: number
  className?: string
}

const CircleLoaderSvg = ({
  radius = 36,
  strokeWidth = 8,
  dashOffset,
  circumference,
  className,
}: CircleLoaderSvgProps): JSX.Element => (
  <svg
    className={cn('strata-w-full strata-h-full', className)}
    viewBox='0 0 80 80'
    preserveAspectRatio='xMidYMid meet'
  >
    <circle
      cx='40'
      cy='40'
      r={radius}
      stroke='currentColor'
      strokeWidth={strokeWidth}
      fill='none'
      strokeDasharray={circumference}
      strokeDashoffset={dashOffset}
      strokeLinecap='round'
    />
  </svg>
)

export default CircleLoaderSvg
